import { createFileRoute } from '@tanstack/react-router';

import { DailyScreen } from '../../features/personal/DailyScreen';

/**
 * `/personal/daily` = المتابعة اليومية (قرار O-37). المسار رقيق والتركيب في الميزة
 * — والخيارات هنا لا تستورد مكوّنًا (‏`check:route-boundary`).
 */
export const Route = createFileRoute('/personal/daily')({ component: DailyScreen });
